import { Injectable, OnDestroy } from '@angular/core';

import { XmStore, XmStoreUtil } from 'src/xm/core/services/store';
import { StoreAction } from 'store/actions';

import { RequestStatus } from 'store/request-status/models';
import { LineDataPlan, RequestResult } from 'store/line/models';

import { ProgressStatus, REQUEST_INTERVAL, REQUEST_TIMEOUT } from 'my-account/constants';

@Injectable()
export class SwitchUtil implements OnDestroy {

    private xmStore: XmStore;
    private requestApiInterval: NodeJS.Timer;
    private switchTimeout: NodeJS.Timer;

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public switchSubstitution(description: string, displayName: string, lineDataPlan: LineDataPlan): string {
        const substituteDescription: string = description.replace('[NICKNAME]', displayName)
            .replace('[SHARED_DATA]', lineDataPlan.sharedData && lineDataPlan.sharedData.toString())
            .replace('[PLAN_GROUP_COST]', lineDataPlan.postSwitch && lineDataPlan.postSwitch.planGroupCost && lineDataPlan.postSwitch.planGroupCost.toString())
            .replace('[LINE_COST]', lineDataPlan.postSwitch && lineDataPlan.postSwitch.lineCost && lineDataPlan.postSwitch.lineCost.toString())
            .replace('[NUMBER_OF_LINES]', lineDataPlan.postSwitch && lineDataPlan.postSwitch.numberOfLines && lineDataPlan.postSwitch.numberOfLines.toString())
            .replace('[REMAINING_UNLIMITED_LINES]', lineDataPlan.postSwitch && lineDataPlan.postSwitch.remainingUnlimitedLines && lineDataPlan.postSwitch.remainingUnlimitedLines.toString())
            .replace('[REMAINING_UNLIMITED_LINES_COST]', lineDataPlan.postSwitch && lineDataPlan.postSwitch.remainingUnlimitedLinesCost && lineDataPlan.postSwitch.remainingUnlimitedLinesCost.toString());

        if (((lineDataPlan.isUnlimited && lineDataPlan.postSwitch.numberOfLines > 1) ||
        (!lineDataPlan.isUnlimited && lineDataPlan.postSwitch.remainingUnlimitedLines > 1))) {
            return substituteDescription.replace('[MULTILINE_SUFFIX]', 's');
        }

        return substituteDescription.replace('[MULTILINE_SUFFIX]', '');
    }

    public postApis(storeActionName: string, bucketId?: string, accountId?: string, lineId?: string, planId?: string): Promise<RequestStatus> {
        return XmStoreUtil.defaultCatch(this.xmStore.persist<RequestStatus>(storeActionName, { bucketId, accountId, lineId, planId }));
    }

    public initPolling(requestId: string): void {
        this.requestApiInterval = setInterval(() => {
            this.queryStatus(requestId).then((requestStatus: RequestStatus) => {
                if (requestStatus.status === ProgressStatus.SUCCESS || requestStatus.status === ProgressStatus.FAIL) {
                    // if status is SUCCESS, complete Addon right away
                    this.completePolling(requestStatus.status);
                } else if (!this.switchTimeout && requestStatus.status === ProgressStatus.IN_PROGRESS) {
                    // set timeout only once when got status IN_PROGRESS
                    this.switchTimeout = setTimeout(() => {
                        this.completePolling(requestStatus.status);
                    }, REQUEST_TIMEOUT);
                }
            }).catch(() => {
                // set timeout if request api is failing
                this.switchTimeout = setTimeout(() => {
                    this.completePolling(ProgressStatus.FAIL);
                }, REQUEST_TIMEOUT);
            });
        }, REQUEST_INTERVAL);
    }

    public ngOnDestroy(): void {
        clearInterval(this.requestApiInterval);
        clearTimeout(this.switchTimeout);
        this.requestApiInterval = undefined;
        this.switchTimeout = undefined;
    }

    private queryStatus(requestId: string): Promise<RequestStatus> {
        return this.xmStore.queryPromise<RequestStatus>(StoreAction.GET_REQUEST_STATUS, { requestId });
    }

    private completePolling(requestStatus: string): void {
        XmStoreUtil.defaultCatch(this.xmStore.persist<RequestResult>(StoreAction.SAVE_REQUEST_RESULT, { requestStatus }));
        clearInterval(this.requestApiInterval);
        clearTimeout(this.switchTimeout);
        this.requestApiInterval = undefined;
        this.switchTimeout = undefined;
    }
}
